import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationAM from "./locales/am.json";
import translationEN from "./locales/en.json";
import translationRU from "./locales/ru.json";
import { applyLanguage, getSavedLanguage } from "./utils/language";

const resources = {
  en: {
    translation: translationEN,
  },
  am: {
    translation: translationAM,
  },
  ru: {
    translation: translationRU,
  },
};

i18n.on("languageChanged", applyLanguage);
i18n.use(initReactI18next).init({
  // Keep i18next and the lesson API on the same language after a reload.
  // Previously the UI always restarted in Armenian while lessonLanguage()
  // could read a different saved language (or default to English).
  lng: getSavedLanguage(),
  // UX-01: fall back to English (now fully populated) and never render an empty
  // string for a missing key — previously fallbackLng was "am", so selecting
  // English/Russian showed blank or Armenian text.
  fallbackLng: "en",
  returnEmptyString: false,
  interpolation: {
    escapeValue: false,
  },
  resources,
});

export default i18n;
